import { handleError, hasError, tryCatch } from '@repo/shared/api/helpers'
import { TasksRoutes } from '@repo/shared/routes-tasks'
import { AxiosInstance } from 'axios'

import { buildBeneficiaryTaskFromDto } from '@/external/api/helpers'
import { ITasksApi } from '@/spi/api/tasks'

export const buildTasksApi = (axios: AxiosInstance): ITasksApi => ({
  createMany: async ({ organizationId, fields, filters, scope }) => {
    const response = await tryCatch(async () =>
      axios.post<typeof TasksRoutes.createMany.response>(
        TasksRoutes.createMany.getPath({ organizationId }),
        { payload: { fields, filters, scope } } satisfies typeof TasksRoutes.createMany.request,
      ),
    )
    if (hasError(response)) return handleError(response)
    return { success: true }
  },

  createOne: async ({ organizationId, beneficiaryId, fields }) => {
    const response = await tryCatch(async () =>
      axios.post<typeof TasksRoutes.createOne.response>(
        TasksRoutes.createOne.getPath({ organizationId, beneficiaryId }),
        { payload: { fields } } satisfies typeof TasksRoutes.createOne.request,
      ),
    )
    if (hasError(response)) return handleError(response)
    return buildBeneficiaryTaskFromDto(response.data)
  },

  updateOne: async ({ organizationId, beneficiaryId, taskId, fields }) => {
    const response = await tryCatch(async () =>
      axios.patch<typeof TasksRoutes.updateOne.response>(
        TasksRoutes.updateOne.getPath({ organizationId, beneficiaryId, taskId }),
        { payload: { fields } } satisfies typeof TasksRoutes.updateOne.request,
      ),
    )
    if (hasError(response)) return handleError(response)
    return buildBeneficiaryTaskFromDto(response.data)
  },

  restoreOne: async ({ organizationId, beneficiaryId, taskId }) => {
    const response = await tryCatch(async () =>
      axios.get<typeof TasksRoutes.restoreOne.response>(
        TasksRoutes.restoreOne.getPath({ organizationId, beneficiaryId, taskId }),
      ),
    )
    if (hasError(response)) return handleError(response)
    return buildBeneficiaryTaskFromDto(response.data)
  },

  deleteOne: async ({ organizationId, beneficiaryId, taskId }) => {
    const response = await tryCatch(async () =>
      axios.delete<typeof TasksRoutes.deleteOne.response>(
        TasksRoutes.deleteOne.getPath({ organizationId, beneficiaryId, taskId }),
      ),
    )
    if (hasError(response)) return handleError(response)
    return { success: true }
  },

  getAll: async ({ organizationId, beneficiaryId }) => {
    const response = await tryCatch(async () =>
      axios.get<typeof TasksRoutes.getAll.response>(
        TasksRoutes.getAll.getPath({ organizationId, beneficiaryId }),
      ),
    )
    if (hasError(response)) return handleError(response)
    return response.data.map(buildBeneficiaryTaskFromDto)
  },
})
